import * as api from '../api';

// eslint-disable-next-line
export const getTaskPrefixes = (args) => {
  return api.callGet('/manager/task-prefixes', args);
};
